var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7471 15.8568H8.68738L7.14283 9.79092C7.06952 9.51189 6.91386 9.26521 6.68489 9.14895C6.11346 8.85677 5.48379 8.62425 4.79688 8.50697V8.27344H8.11496C8.5729 8.27344 8.91636 8.62425 8.9736 9.03167L9.775 13.4072L11.8337 8.27344H13.8362L10.7471 15.8568ZM14.9843 15.8568H13.0391L14.6409 8.27344H16.5861L14.9843 15.8568ZM19.1023 10.3773C19.1596 9.96884 19.503 9.7353 19.9037 9.7353C20.5334 9.67667 21.2193 9.79394 21.7917 10.0851L22.1352 8.45237C21.5628 8.21884 20.9331 8.10156 20.3617 8.10156C18.4737 8.10156 17.0998 9.15197 17.0998 10.6098C17.0998 11.7188 18.073 12.3012 18.7599 12.652C19.503 13.0018 19.7892 13.2353 19.732 13.5851C19.732 14.1098 19.1596 14.3433 18.5881 14.3433C17.9012 14.3433 17.2143 14.1684 16.5856 13.8763L16.2422 15.51C16.9291 15.8012 17.6723 15.9185 18.3592 15.9185C20.4762 15.9761 21.7917 14.9267 21.7917 13.3516C21.7917 11.368 19.1023 11.2518 19.1023 10.3773ZM28.5995 15.8568L27.055 8.27344H25.3959C25.0525 8.27344 24.709 8.50697 24.5945 8.85677L21.7344 15.8568H23.7369L24.1366 14.7488H26.597L26.826 15.8568H28.5995ZM25.6788 10.3203L26.2502 13.1784H24.6484L25.6788 10.3203Z",
    fill: "#172B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/VisaCard.35e58b62b122efe946176af00d5bfc27.svg";
export { ForwardRef as ReactComponent };